/***************************************************************************************
 * FileName      : DeviceCategory.ts
 * Description   : 디바이스 카테고리 enum (Equipment / Control / Sensor 3종 고정)
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.10
 * Modified Date :
 * Reference     : packages/scjeil-smart_ict_lab-app/assets/json/equipment/*.json → devices[].category
 ***************************************************************************************/

// 2026.02.10 : 박은정 : 디바이스 카테고리 enum (확장 가능성 낮음 → 엄격 enum)
// - Equipment : 탱크, 열교환기, 증류탑 등 수동 설비
// - Control   : 펌프, 히터, 밸브 등 제어 가능 장치
// - Sensor    : 온도계, 압력계, 유량계 등 측정 장치
export enum DeviceCategory {
  Equipment = 'Equipment',
  Control = 'Control',
  Sensor = 'Sensor',
}

